import React, { useEffect, useState } from "react";
import { useSecureFetch } from "../hooks/useSecureFetch";

const TestData = () => {
    const { secureFetch } = useSecureFetch();
    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await secureFetch("https://server.enjoywiki.com/flip-server/payments");
                setData(result);
            } catch (err) {
                console.error("Error fetching data:", err);
            }
        };

        fetchData();
    }, [secureFetch]);

    return (
        <div className="mt-5 vh-100">
            <h2>Fetched Data:</h2>
            {data ? (
                data.map((item, index) => (
                    <div key={index}>
                        <p>ID: {item._id}</p>
                        <p>Email: {item.email}</p>
                    </div>
                ))
            ) : (
                <p>No data available</p>
            )}
        </div>
    );
};

export default TestData;